import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'

const FIELD_LENGTH = 200
const NUMBER_LENGTH = 50

const createPersonSchema = (required = false, isAccessRole) => {
  const baseSchema = Joi.object({
    label: Joi.string()
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-№ ]+$'))
      .error(errorsResolver({
        pattern: 'Поле содержит некорректные символы'
      })),
    value: Joi.number().error(errorsResolver({
      number: 'Должно быть число'
    }))
  });

  return required ? baseSchema.required().error(errorsResolver({
    required: isAccessRole 
      ? "Функция оформления описи доступна только для товароведа" 
      :  'Обязательное поле для ввода'
  })) : baseSchema;
};

export const thingsSchema = Joi.object({
  destCashBoxId: Joi.object({
    label: Joi.string()
      .max(FIELD_LENGTH)
      .required('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-№ ]*$'))
      .error(errorsResolver({
        max: `Получатель должен быть до ${FIELD_LENGTH} символов`,
        required: `Получатель обязательное поле`,
        pattern: `Получатель содержит некорректные символы`
      })),
    value: Joi.number()
      .error(errorsResolver({
        number: `Должно быть число`
      }))
  }),
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9]*$'))
    .required('')
    .error(errorsResolver({
      max: `Номер документа должен быть до ${NUMBER_LENGTH} символов`,
      required: `Номер документа обязательное поле`,
      pattern: 'Номер документа должен быть числом',
    })),
  transferDate: Joi.date()
    .required('')
    .iso()
    .min(Joi.ref('permissibleDate'))
    .error(errorsResolver({
      required: `Дата обязательное поле`,
      dateMin: `Некорректная дата`,
      dateFormat: `Некорректная дата`
    })),
  permissibleDate: Joi.date(),
  reason: Joi.string()
    .max(FIELD_LENGTH)
    .allow('')
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.,№ ]*$'))
    .error(errorsResolver({
      max: `Основание должно быть до ${FIELD_LENGTH} символов`,
      pattern: `Основание содержит некорректные символы`
    }))
})

export const puritiesShema = Joi.object({
  destCashBoxId: Joi.object({
    label: Joi.string()
      .max(FIELD_LENGTH)
      .required('')
      .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-№ ]*$'))
      .error(errorsResolver({
        max: `Получатель должен быть до ${FIELD_LENGTH} символов`,
        required: `Получатель обязательное поле`,
        pattern: `Получатель содержит некорректные символы`
      })),
    value: Joi.number()
      .error(errorsResolver({
        number: `Должно быть число`
      }))
  }),
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9]*$'))
    .required('')
    .error(errorsResolver({
      max: `Номер документа должен быть до ${NUMBER_LENGTH} символов`,
      required: `Номер документа обязательное поле`,
      pattern: 'Номер документа должен быть числом',
    })),
  transferDate: Joi.date()
    .required('')
    .iso()
    .min(Joi.ref('permissibleDate'))
    .error(errorsResolver({
      required: `Дата обязательное поле`,
      dateMin: `Некорректная дата`,
      dateFormat: `Некорректная дата`
    })),
  permissibleDate: Joi.date(), 
})

export const internalMovementSchema = ({isAccessRole, isViewThings}) => puritiesShema.keys({
  sendApplierId: createPersonSchema(!isViewThings),
  senderId: createPersonSchema(true, isAccessRole),
  deliverReceptionistId: createPersonSchema(),
  accepterId: createPersonSchema(isViewThings),
  reason: Joi.string()
    .max(FIELD_LENGTH)
    .allow('')
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.,№ ]*$'))
    .error(errorsResolver({
      max: `Основание должно быть до ${FIELD_LENGTH} символов`,
      pattern: `Основание содержит некорректные символы`
    }))
})

export const anotherSchema = Joi.object({
  destCashBoxId: Joi.object({
    label: Joi.string()
      .max(FIELD_LENGTH)
      .required('')
      .error(errorsResolver({
        max: `Получатель должен быть до ${FIELD_LENGTH} символов`,
        required: `Получатель обязательное поле`,
      })),
    value: Joi.number()
      .error(errorsResolver({
        number: `Должно быть число`
      }))
  }),
  documentNumber: Joi.string()
    .max(NUMBER_LENGTH)
    .pattern(new RegExp('^[0-9]*$'))
    .required('')
    .error(errorsResolver({
      max: `Номер документа должен быть до ${NUMBER_LENGTH} символов`,
      required: `Номер документа обязательное поле`,
      pattern: 'Номер документа должен быть числом',
    })),
  reason: Joi.string()
    .max(FIELD_LENGTH)
    .allow('')
    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.,№ ]*$'))
    .error(errorsResolver({
      max: `Основание должно быть до ${FIELD_LENGTH} символов`,
      pattern: `Основание содержит некорректные символы`
    }))
})
